<template>
  <footer class="footer">
    <div class="container-fluid">
      <nav>
        <ul class="footer-menu">
          <!-- <li>
            <router-link :to="{path:'/admin'}">Dashboard</router-link>
          </li> -->
        </ul>
      </nav>
      <div class="copyright text-right">
        &copy; Coded with
        <i class="fa fa-heart heart"></i> by
        <a href="https://binarcode.com" target="_blank">BinarCode</a>.
        Designed by <a href="https://www.creative-tim.com/?ref=pdf-vuejs" target="_blank">Creative Tim</a>.
        <br/>Extended and Customised by <a href="https://git.naspersclassifieds.com/static/costs-dashboard">OLX - Cloud Economics and Governance</a>.
        <br/>{{commit_info}}
      </div>
    </div>
  </footer>
</template>
<script>
  import commit_info from '@/commit_info.txt'
  export default {
    created(){
      this.commit_info = commit_info
    }

  }

</script>
<style>

</style>
